import { useState } from "react";
import { useAdmin } from "./common";
import { apiError } from "../api";

export default function Login() {
  const { login } = useAdmin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [hata, setHata] = useState("");
  const [bekle, setBekle] = useState(false);
  const gir = async (e) => {
    e.preventDefault(); setHata(""); setBekle(true);
    try { await login(email, password); }
    catch (err) { setHata(apiError(err)); }
    finally { setBekle(false); }
  };
  return (
    <div className="a-login">
      <div className="kutu">
        <h1>ÖZALP</h1>
        <p className="veri" style={{ marginBottom: 24 }}>Yönetim Paneli</p>
        <form className="a-form" onSubmit={gir}>
          <div><label>E-posta</label><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" required /></div>
          <div><label>Şifre</label><input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" required /></div>
          {hata && <div className="form-hata" data-testid="admin-login-hata">{hata}</div>}
          <button className="a-btn bal" disabled={bekle} data-testid="admin-login-btn">{bekle ? "Giriş yapılıyor…" : "Giriş yap"}</button>
        </form>
      </div>
    </div>
  );
}
